import React, { useState, useCallback, useEffect } from 'react'
import Snackbar from '@mui/material/Snackbar'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../types/state'
import { RefreshActions } from '../state/refresh'

export const ToastProvider = (): JSX.Element => {
  const dispatch = useDispatch()
  const { toastMessage } = useSelector((state: State) => state.refresh)
  const [toast, setToast] = useState({
    open: false,
    message: '',
    duration: 3000
  })

  useEffect(() => {
    if (toastMessage !== null) {
      showToast(toastMessage)
      dispatch(RefreshActions.resetToastMessage())
    }
  }, [toastMessage])

  const showToast = useCallback((message: string) => {
    setToast({
      open: true,
      message,
      duration: 3000
    })
  }, [])

  const closeToast = useCallback(() => {
    setToast(prevToast => ({ ...prevToast, open: false }))
  }, [])

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={toast.open}
      message={toast.message}
      autoHideDuration={toast.duration}
      onClose={closeToast}
    />
  )
}
